import _extends from "@babel/runtime/helpers/extends";
import { HTMLContent, RadioList } from '@datacamp/le-shared-components';
import Button from '@datacamp/waffles-button';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ExerciseLayout from './ExerciseLayout';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MultipleChoiceExercise = _ref => {
  let {
    completionPaneVisible,
    exercise,
    feedbackMessages,
    hideCompletionPane,
    interactionBlocked,
    onExerciseFinished,
    onRate,
    onSelectOption,
    onSubmitAnswer,
    resetWorkbook,
    selectedOption,
    showExercise,
    showHint,
    successMessage,
    workbook,
    workbookReady,
    xpLost
  } = _ref;
  const {
    t
  } = useTranslation();
  return ___EmotionJSX(ExerciseLayout, _extends({
    completionPaneVisible,
    exercise,
    feedbackMessages,
    hideCompletionPane,
    interactionBlocked,
    onExerciseFinished,
    onRate,
    resetWorkbook,
    showExercise,
    showHint,
    successMessage,
    workbook,
    workbookReady,
    xpLost
  }, {
    instructions: ex => ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h4", null, t('MultipleChoiceExercise.heading')), ___EmotionJSX(RadioList, {
      name: "mce-options",
      onChange: onSelectOption,
      value: selectedOption
    }, ex.possibleAnswers.map((_ref2, index) => {
      let {
        answer
      } = _ref2;
      return ___EmotionJSX(RadioList.Item, {
        key: index,
        value: "".concat(index)
      }, ___EmotionJSX(HTMLContent, {
        html: answer
      }));
    })), ___EmotionJSX("div", {
      className: "dc-u-fx dc-u-fx-jcsb dc-u-fx-fdrr"
    }, ___EmotionJSX(Button, {
      appearance: "primary",
      disabled: selectedOption === undefined,
      intent: "success",
      onClick: onSubmitAnswer,
      size: "small"
    }, t('MultipleChoiceExercise.button'))))
  }));
};
export default MultipleChoiceExercise;